/**
 * Modal overlay aniqlash — bitta manba (DRY).
 *
 * Ilovadagi barcha modallarni qamrab oladi:
 *   - `[data-slot$="-overlay"]` — Radix dialog/alert-dialog/sheet overlaylari
 *   - `.fixed.inset-0[class*="bg-black/"]` — custom modal overlaylari
 *
 * Ishlatiladi:
 *   - useModalScrollLock — modal ochiq bo'lsa <main> scroll'ini qulflaydi
 *   - ScrollNav — modal ochiq bo'lsa ↑/↓ klaviatura scroll'ini o'chiradi
 *     (scrollBy() overflow:hidden'ga qaramay ishlaydi, shuning uchun bu kerak)
 */
export const MODAL_OVERLAY_SELECTOR = '[data-slot$="-overlay"], .fixed.inset-0[class*="bg-black/"]';

/** Hozir biror modal ochiqmi (DOM'da overlay mavjudmi)? */
export function isAnyModalOpen(): boolean {
  return document.querySelector(MODAL_OVERLAY_SELECTOR) !== null;
}
